const SAFE_ID = /^\d+$/;

export const safeIfcReturnDrawingId = (raw) => {
  const value = String(raw ?? "").trim();
  return SAFE_ID.test(value) ? value : null;
};

export const ifcViewerBackPath = ({
  projectId,
  drawingId,
  linkDrawingId,
} = {}) => {
  const fromDrawing =
    safeIfcReturnDrawingId(drawingId) || safeIfcReturnDrawingId(linkDrawingId);
  if (fromDrawing) return `/dashboard/drawings/${fromDrawing}`;
  if (projectId != null && String(projectId).trim() !== "") {
    return `/dashboard/projects/${projectId}`;
  }
  return "/dashboard";
};
